module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-2-Weight-based-bullying-What-can-I-do-ES-58c1c676a16a8cfed7ba5ed4f8a68c24.pdf";